// src/components/elements/TLSpinner/TLSpinner.tsx
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  --border-radius-large: 12px;\n  --border-radius-medium: 8px;\n\n  /* Positioning ancestor only. NO z-index here, ever — see the note above this block. */\n  position: relative;\n\n  .dropdown-trigger {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    padding: 8px 12px;\n    border: none;\n    border-radius: var(--border-radius-medium);\n    background: rgba(255, 255, 255, 0.6);\n    backdrop-filter: blur(6px);\n    box-shadow:\n      0px 0px 11px 1px rgba(228, 255, 254, 0.55),\n      0px 3px 11px 0px rgba(0, 0, 0, 0.05);\n    cursor: pointer;\n    transition: all 0.2s ease;\n    color: #242424;\n    font-size: 14px;\n    line-height: 1.4;\n    min-height: 40px;\n\n    &:hover {\n      background: rgba(255, 255, 255, 0.8);\n      box-shadow:\n        0px 0px 15px 2px rgba(228, 255, 254, 0.7),\n        0px 4px 15px 0px rgba(0, 0, 0, 0.08);\n    }\n\n    /* Mouse focus stays ring-free (preserves the original look); keyboard focus gets a\n       visible, token-based ring (WCAG 2.4.7). */\n    &:focus {\n      outline: none;\n    }\n\n    &:focus-visible {\n      outline: 2px solid var(--tl-brand-focus-ring, var(--tl-cyan, #00bbcc));\n      outline-offset: 2px;\n    }\n\n    &.disabled,\n    &:disabled {\n      opacity: 0.5;\n      cursor: not-allowed;\n      pointer-events: none;\n    }\n  }\n\n  .dropdown-trigger .option-icon {\n    width: 16px;\n    height: 16px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: #242424;\n  }\n\n  .dropdown-menu .option-icon {\n    width: 16px;\n    height: 16px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: #242424;\n  }\n\n  .option-label {\n    flex: 1;\n    text-align: left;\n  }\n\n  .chevron {\n    width: 16px;\n    height: 16px;\n    flex-shrink: 0;\n    transition: transform 0.2s ease;\n    color: #242424;\n\n    &.open {\n      transform: rotate(180deg);\n    }\n  }\n\n  /* OUTER CONTAINER - blue glow and full rounded corners are applied directly here */\n  .dropdown-container {\n    position: absolute;\n    top: 46px;\n    left: 0;\n    z-index: ",
        ";\n    border-radius: var(--border-radius-medium);\n    box-shadow: 0px 0px 11px 1px rgba(228, 255, 254, 0.55);\n    background-color: rgba(255, 255, 255, 0.4);\n    padding: 0.2rem;\n  }\n\n  /* INNER CONTAINER - matches .user-menu styling exactly */\n  .dropdown-menu {\n    width: 100%;\n    border-radius: var(--border-radius-medium);\n    padding: 0.5rem;\n\n    background: rgba(255, 255, 255, 0.16);\n    box-shadow:\n      0.852px 0.852px 6.816px 0px rgba(255, 255, 255, 0.08) inset,\n      1.704px 1.704px 49.413px 0px rgba(228, 255, 255, 0.15);\n    backdrop-filter: blur(17.8px);\n\n    ul {\n      list-style: none;\n      padding: 0;\n      margin: 0;\n    }\n\n    li {\n      height: 26px;\n      padding: 1rem 0.75rem;\n      margin-bottom: 0.5rem;\n      font-size: 14px;\n      line-height: 100%;\n      display: flex;\n      align-items: center;\n      border-radius: var(--border-radius-medium);\n      cursor: pointer;\n      color: #242424;\n      transition: all 0.2s ease;\n\n      &:last-child {\n        margin-bottom: 0;\n      }\n\n      /* Mouse click stays ring-free; keyboard (roving) focus gets a visible ring. */\n      &:focus {\n        outline: none;\n      }\n\n      &:focus-visible {\n        outline: 2px solid var(--tl-brand-focus-ring, var(--tl-cyan, #00bbcc));\n        outline-offset: -2px;\n      }\n\n      .option-icon {\n        margin-right: 0.5rem;\n        color: #242424;\n      }\n\n      .option-label {\n        flex: 1;\n        padding-right: 0; /* Default padding for non-scrollbar dropdowns */\n        white-space: nowrap;\n      }\n\n      &:hover {\n        color: #00bbcc;\n        font-weight: 500;\n        background-color: #ffffff;\n\n        .option-icon {\n          color: #00bbcc;\n        }\n      }\n\n      &.active {\n        color: #00bbcc;\n        font-weight: 600;\n        background-color: rgba(0, 187, 204, 0.1);\n\n        .option-icon {\n          color: #00bbcc;\n        }\n      }\n    }\n  }\n\n  /* Special styling for dropdowns with scrollbars */\n  &.has-scrollbar {\n    .dropdown-menu li {\n      margin-right: 20px; /* Extra margin for scrollbar */\n\n      .option-label {\n        padding-right: 4px; /* Extra padding for scrollbar */\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import { Spinner } from "@fluentui/react-components";
import { jsx } from "react/jsx-runtime";
var TLSpinner = function(param) {
    var className = param.className, props = param.props, custom = param.custom;
    return /* @__PURE__ */ jsx("div", {
        className: className,
        children: custom ? custom : /* @__PURE__ */ jsx(Spinner, _object_spread({}, props))
    });
};
var TLSpinner_default = TLSpinner;
// src/hooks/useClickOutside.ts
import { useRef, useEffect } from "react";
var useClickOutside = function(onClickOutside, excludeRefs) {
    var ref = useRef(null);
    useEffect(function() {
        var handleClickOutside = function(event) {
            if (ref.current && ref.current.contains(event.target)) {
                return;
            }
            if (excludeRefs) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = excludeRefs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var excludeRef = _step.value;
                        if (excludeRef.current && excludeRef.current.contains(event.target)) {
                            return;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
            onClickOutside();
        };
        document.addEventListener("mousedown", handleClickOutside);
        return function() {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        onClickOutside,
        excludeRefs
    ]);
    return ref;
};
// src/components/BaseDropdown/BaseDropdown.tsx
import { useEffect as useEffect2, useId, useRef as useRef2, useState } from "react";
import styled from "styled-components";
import { ChevronDown16Regular } from "@fluentui/react-icons";
import { Scrollbar } from "@repo/design-system";
import { zIndex } from "@repo/design-tokens";
import { Fragment, jsx as jsx2, jsxs } from "react/jsx-runtime";
var TRIGGER_KEYS_OWNED = JSON.stringify({
    focusable: {
        ignoreKeydown: {
            ArrowDown: true,
            ArrowUp: true
        }
    }
});
var LIST_KEYS_OWNED = JSON.stringify({
    focusable: {
        ignoreKeydown: {
            ArrowDown: true,
            ArrowUp: true,
            ArrowLeft: true,
            ArrowRight: true,
            Home: true,
            End: true,
            PageUp: true,
            PageDown: true
        }
    }
});
var BaseDropdown = function(param) {
    var className = param.className, currentValue = param.currentValue, options = param.options, onOptionChange = param.onOptionChange, triggerContent = param.triggerContent, _param_maxHeight = param.maxHeight, maxHeight = _param_maxHeight === void 0 ? 300 : _param_maxHeight, _param_width = param.width, width = _param_width === void 0 ? "auto" : _param_width, _param_minWidth = param.minWidth, minWidth = _param_minWidth === void 0 ? "160px" : _param_minWidth, _param_hasScrollbar = param.hasScrollbar, hasScrollbar = _param_hasScrollbar === void 0 ? false : _param_hasScrollbar, _param_disabled = param.disabled, disabled = _param_disabled === void 0 ? false : _param_disabled, ariaLabel = param.ariaLabel;
    var _useState = _sliced_to_array(useState(false), 2), isOpen = _useState[0], setIsOpen = _useState[1];
    var _useState1 = _sliced_to_array(useState(0), 2), activeIndex = _useState1[0], setActiveIndex = _useState1[1];
    var dropdownRef = useClickOutside(function() {
        return setIsOpen(false);
    });
    var triggerRef = useRef2(null);
    var itemRefs = useRef2([]);
    var pendingFocusRef = useRef2(null);
    var generatedId = useId();
    var triggerId = "".concat(generatedId, "-trigger");
    var listId = "".concat(generatedId, "-list");
    var getCurrentOption = function() {
        return options.find(function(option) {
            return option.value === currentValue;
        }) || options[0];
    };
    var currentIndex = function() {
        var index = options.findIndex(function(option) {
            return option.value === currentValue;
        });
        return index >= 0 ? index : 0;
    };
    var handleOptionSelect = function(value) {
        onOptionChange(value);
        setIsOpen(false);
    };
    var openMenu = function(focusIndex) {
        pendingFocusRef.current = focusIndex;
        setActiveIndex(focusIndex);
        setIsOpen(true);
    };
    var closeMenu = function(returnFocusToTrigger) {
        pendingFocusRef.current = null;
        setIsOpen(false);
        if (returnFocusToTrigger) {
            requestAnimationFrame(function() {
                var _triggerRef_current;
                return (_triggerRef_current = triggerRef.current) === null || _triggerRef_current === void 0 ? void 0 : _triggerRef_current.focus();
            });
        }
    };
    var focusItem = function(index) {
        var _itemRefs_current_wrapped;
        var count = options.length;
        if (count === 0) return;
        var wrapped = (index % count + count) % count;
        setActiveIndex(wrapped);
        (_itemRefs_current_wrapped = itemRefs.current[wrapped]) === null || _itemRefs_current_wrapped === void 0 ? void 0 : _itemRefs_current_wrapped.focus();
    };
    useEffect2(function() {
        if (isOpen && pendingFocusRef.current !== null) {
            var _itemRefs_current_index;
            var index = pendingFocusRef.current;
            pendingFocusRef.current = null;
            (_itemRefs_current_index = itemRefs.current[index]) === null || _itemRefs_current_index === void 0 ? void 0 : _itemRefs_current_index.focus();
        }
    }, [
        isOpen
    ]);
    var handleTriggerKeyDown = function(event) {
        if (disabled) return;
        switch(event.key){
            case "Enter":
            case " ":
            case "ArrowDown":
                event.preventDefault();
                if (isOpen) {
                    focusItem(activeIndex);
                } else {
                    openMenu(currentIndex());
                }
                break;
            case "ArrowUp":
                event.preventDefault();
                if (isOpen) {
                    focusItem(options.length - 1);
                } else {
                    openMenu(options.length - 1);
                }
                break;
            case "Escape":
                if (isOpen) {
                    event.preventDefault();
                    closeMenu(false);
                }
                break;
            default:
                break;
        }
    };
    var handleItemKeyDown = function(event, value) {
        switch(event.key){
            case "ArrowDown":
                event.preventDefault();
                focusItem(activeIndex + 1);
                break;
            case "ArrowUp":
                event.preventDefault();
                focusItem(activeIndex - 1);
                break;
            case "Home":
                event.preventDefault();
                focusItem(0);
                break;
            case "End":
                event.preventDefault();
                focusItem(options.length - 1);
                break;
            case "Enter":
            case " ":
                event.preventDefault();
                onOptionChange(value);
                closeMenu(true);
                break;
            case "Escape":
                event.preventDefault();
                closeMenu(true);
                break;
            case "Tab":
                setIsOpen(false);
                break;
            default:
                break;
        }
    };
    var currentOption = getCurrentOption();
    var rovingIndex = options.length > 0 ? Math.min(activeIndex, options.length - 1) : 0;
    return /* @__PURE__ */ jsxs("div", {
        className: "".concat(className, " ").concat(hasScrollbar ? "has-scrollbar" : ""),
        ref: dropdownRef,
        onBlur: function(event) {
            var next = event.relatedTarget;
            if (isOpen && next && !event.currentTarget.contains(next)) setIsOpen(false);
        },
        children: [
            /* @__PURE__ */ jsxs("button", {
                ref: triggerRef,
                id: triggerId,
                className: "dropdown-trigger ".concat(disabled ? "disabled" : ""),
                onClick: function() {
                    if (disabled) return;
                    if (!isOpen) setActiveIndex(currentIndex());
                    setIsOpen(!isOpen);
                },
                onKeyDown: handleTriggerKeyDown,
                "data-tabster": TRIGGER_KEYS_OWNED,
                "aria-label": ariaLabel || void 0,
                "aria-haspopup": "listbox",
                "aria-expanded": isOpen,
                "aria-controls": isOpen ? listId : void 0,
                disabled: disabled,
                style: {
                    width: width,
                    minWidth: minWidth
                },
                children: [
                    triggerContent || /* @__PURE__ */ jsxs(Fragment, {
                        children: [
                            /* @__PURE__ */ jsx2("span", {
                                className: "option-icon",
                                children: currentOption === null || currentOption === void 0 ? void 0 : currentOption.icon
                            }),
                            /* @__PURE__ */ jsx2("span", {
                                className: "option-label",
                                children: currentOption === null || currentOption === void 0 ? void 0 : currentOption.label
                            })
                        ]
                    }),
                    /* @__PURE__ */ jsx2(ChevronDown16Regular, {
                        className: "chevron ".concat(isOpen ? "open" : "")
                    })
                ]
            }),
            isOpen && /* @__PURE__ */ jsx2("div", {
                className: "dropdown-container",
                style: {
                    minWidth: minWidth
                },
                children: /* @__PURE__ */ jsx2("div", {
                    className: "dropdown-menu",
                    children: /* @__PURE__ */ jsx2(Scrollbar, {
                        maxHeight: maxHeight,
                        children: /* @__PURE__ */ jsx2("ul", {
                            id: listId,
                            role: "listbox",
                            "aria-labelledby": triggerId,
                            "aria-orientation": "vertical",
                            "data-tabster": LIST_KEYS_OWNED,
                            children: options.map(function(option, index) {
                                var isActive = currentValue === option.value;
                                return /* @__PURE__ */ jsxs("li", {
                                    ref: function(element) {
                                        itemRefs.current[index] = element;
                                    },
                                    className: isActive ? "active" : "",
                                    role: "option",
                                    tabIndex: index === rovingIndex ? 0 : -1,
                                    "aria-selected": isActive ? "true" : "false",
                                    onClick: function() {
                                        return handleOptionSelect(option.value);
                                    },
                                    onKeyDown: function(event) {
                                        return handleItemKeyDown(event, option.value);
                                    },
                                    children: [
                                        /* @__PURE__ */ jsx2("span", {
                                            className: "option-icon",
                                            children: option.icon
                                        }),
                                        /* @__PURE__ */ jsx2("span", {
                                            className: "option-label",
                                            children: option.label
                                        })
                                    ]
                                }, option.value);
                            })
                        })
                    })
                })
            })
        ]
    });
};
var StyledBaseDropdown = styled(BaseDropdown)(_templateObject(), zIndex.popover);
var BaseDropdown_default = StyledBaseDropdown;
export { TLSpinner_default, useClickOutside, BaseDropdown_default };
